import './conf/sentry';
import React from 'react';
// 💡 REVERT 1: Back to legacy ReactDOM import
import ReactDOM from 'react-dom';
import axios from 'axios';
import { Provider } from 'mobx-react';
import * as Sentry from '@sentry/react';
import { ThemeProvider } from '@material-ui/styles';
import { CssBaseline } from '@material-ui/core';
import App from './app/App';
import './index.css';

import { LayoutProvider } from './app/context/LayoutContext';
import {
  ThemeProvider as ThemeChangeProvider,
  ThemeStateContext,
} from './app/context/ThemeContext';

import config, { configureAWSWithHostedUI } from './conf/config';

import store from './store';

import TagManager from 'react-gtm-module';
import {
  initIconFonts,
} from './app/fontawesome';

initIconFonts();

/* Google Tag Manager */
const tagManagerArgs = {
    gtmId: 'GTM-TT5XK43',
};

TagManager.initialize(tagManagerArgs);

configureAWSWithHostedUI();


/*
 * Override axios defaults...
 */
axios.defaults.baseURL = config.baseURLApi;
axios.defaults.headers.common['Content-Type'] = 'application/json';

// 💡 REVERT 3: Back to legacy ReactDOM.render() mounting method
ReactDOM.render(
  <Provider
    envStore={store.envStore}
    userStore={store.userStore}
    schedulesStore={store.schedulesStore}
    eventsStore={store.eventsStore}
    optinsStore={store.optinsStore}
    webhooksStore={store.webhooksStore}
    errorStore={store.errorStore}
    labelsStore={store.labelsStore}
    subscribersStore={store.subscribersStore}
    apikeyStore={store.apikeyStore}
    buttonsStore={store.buttonsStore}
    dashboardStore={store.dashboardStore}
    billingStore={store.billingStore}
    stylesStore={store.stylesStore}
    publishersStore={store.publishersStore}
    connectStore={store.connectStore}
  >
    <LayoutProvider>
          <ThemeChangeProvider>
            <ThemeStateContext.Consumer>
              {theme => (
                <ThemeProvider theme={theme}>
                  <CssBaseline />
                  <App />
                </ThemeProvider>
              )}
            </ThemeStateContext.Consumer>
          </ThemeChangeProvider>
    </LayoutProvider>
  </Provider>,
  document.getElementById('root')
);